<template>
  <tr class="library-item-tr f-thead">
    <template v-if="game">
      <td class="draghandle" :class="disableReorder ? '-disabled' : ''">
        <UIIcon class="w2 fill-inherit" name="menu" />
      </td>
      <td
        class="imagecell dn dtc-m"
        style="max-width: 150px; min-width: 100px; width: 10%;"
      >
        <RatioContainer class="ratiocontainer" :ratio="46.5863">
          <LazyImg
            class="posterimg absolute w-100 h-100"
            :style="{ opacity: loading ? 0.5 : 1 }"
            :src="game.imageUrl"
            :srcset="game.imageSrcSet"
            :placeholder="game.imageSvgUrl"
            :alt="game.title"
          />
        </RatioContainer>
      </td>
      <td class="titlecell">
        <div>
          <!-- <VisibilityObserver @visible="$emit('visible', game)" :once="true" /> -->
          <h4
            class="title f-header nowrap dib truncate slate w-100"
            :style="{ opacity: loading ? 0.5 : 1 }"
          >
            {{ game.title }}
          </h4>
        </div>
      </td>
      <template v-if="loading">
        <td colspan="3" class="tr dn dtc-m">
          <h1 class="loading bg-near-white pa2 w-60 dib">&nbsp;</h1>
        </td>
      </template>
      <td class="editcell">
        <UIButton
          tiny
          icon="edit"
          :to="{ name: 'library-show', params: { gameId: game.id } }"
          class="editbtn ml-auto"
          >{{ $t('Edit') }}</UIButton
        >
      </td>
    </template>
  </tr>
</template>

<script>
import UIButton from '@sbvr/common/legacy-shared/components/ui/UIButton.vue';
import UIIcon from '@sbvr/common/legacy-shared/components/ui/UIIcon.vue';
import RatioContainer from '@sbvr/common/legacy-shared/components/utils/RatioContainer.vue';
import LazyImg from '@sbvr/common/legacy-shared/components/utils/LazyImg.vue';
// import VisibilityObserver from '@/core/components/utils/VisibilityObserver';

export default {
  name: 'LibraryItemTr',
  components: {
    UIButton,
    UIIcon,
    LazyImg,
    RatioContainer,
    // VisibilityObserver,
  },
  props: {
    game: { required: true },
    disableReorder: { type: Boolean },
    loading: { type: Boolean },
  },
  computed: {
    ownership () {
      return (this.game && this.game.ownership) || this.game;
    },
  },
};
</script>

<style scoped lang="postcss">
@import '@sbvr/common/legacy-shared/styles';

.library-item-tr {
  --borderWidth: 6px;
  @media (--tablet) {
    --borderWidth: 10px;
  }
  & .w-1 {
    width: 1px;
  }
  & >>> .w2 {
    width: 2em;
  }
  & .currentmonthcost {
    white-space: nowrap;
  }
  & .colorindicator {
    background: var(--colorInfo);
    position: absolute;
    top: 0;
    left: calc(-1 * var(--borderWidth));
    bottom: 0;
    border-top-left-radius: var(--radius);
    border-bottom-left-radius: var(--radius);
    width: 6px;
    @media (--tablet) {
      width: 10px;
    }
  }
  & .pricechangenotification {
  }
  border-collapse: separate;
  border-spacing: var(--borderWidth);
  border: 0;
  & td,
  & th {
    vertical-align: middle;
    padding: 12px 2px;
    @media (--tablet) {
      padding: 8px 5px;
    }
    position: relative;
  }
  & td {
    &:before {
      content: '';
      top: 0;
      left: calc(-1 * var(--borderWidth));
      width: calc(100% + 1px + var(--borderWidth));
      height: 100%;
      position: absolute;
      @apply --panelDropShadow;
      z-index: -2;
      background-color: var(--colorWhite);
    }
    &:after {
      content: '';
      top: 0;
      left: calc(-1 * var(--borderWidth));
      width: calc(100% + 1px + var(--borderWidth));
      height: 100%;
      position: absolute;
      z-index: -1;
      background-color: var(--colorWhite);
    }
    &:first-child:after,
    &:first-child:before {
      border-top-left-radius: var(--radius);
      border-bottom-left-radius: var(--radius);
    }
    &:last-child:after,
    &:last-child:before {
      left: calc(-1 * var(--borderWidth));
      width: calc(100% + 2 * var(--borderWidth));
      border-top-right-radius: var(--radius);
      border-bottom-right-radius: var(--radius);
    }
  }
  & .editcell {
    padding: 0 var(--spacingXS);
    width: 1px;
    white-space: nowrap;
    @media (--tablet) {
      padding: 0 var(--spacingMd);
    }
  }
  & .draghandle {
    cursor: grab;
    position: relative;
    width: 42px;
    text-align: center;
    fill: var(--colorFjord);
    transition: fill 0.4s ease-in-out;
    &.-disabled {
      cursor: not-allowed;
      fill: var(--colorGeyser);
    }
  }
  & .titlecell {
    max-width: 13vw;
  }
  & .warning {
    display: block;
    text-align: left;
  }
  & .loading {
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: loadingPlaceholder;
    animation-timing-function: linear;
    background: #f6f6f6;
    background: linear-gradient(to right, #f6f6f6 8%, #f0f0f0 18%, #f6f6f6 33%);
    background-size: 400px 100%;
  }
  & .currentmonthusage {
    position: relative;
    &:after {
      content: '';
      z-index: 5;
      position: absolute;
      width: 100%;
      height: 140%;
      top: -20%;
      left: 0px;
      border: 1px solid var(--colorGeyser);
      border-width: 0 1px;
    }
  }
}
@keyframes loadingPlaceholder {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
</style>
